import gql from 'graphql-tag';

export default gql`
  mutation AuthLoginViaApple($token: String!) {
    auth {
      loginViaApple(token: $token) {
        ... on OauthToken {
          token
        }
        ... on OauthException {
          code
        }
      }
    }
  }
`;
